import {injectable} from "tsyringe";
import {RenameEmployeeCommand} from "../commands/rename-employee.command";
import {transformer} from "../decorators/transformer.decorator";
import {DataTransferObject} from "../domain/dtos/data-transfer-object.interface";
import {Employee} from "../domain/entities/employee.entity";
import {TransformerHelper} from "../helpers/transformer.helper";
import {AbstractCommandToDtoTransformer} from "./abstract-command-to-dto.transformer";

@injectable()
@transformer({
    source: RenameEmployeeCommand,
    target: `dto`
})
export class RenameEmployeeCommandToDtoTransformer extends AbstractCommandToDtoTransformer<Employee> {

    protected async toDTO(employee: Employee): Promise<DataTransferObject> {
        return TransformerHelper.toDTO(employee);
    }
}